var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_grid _grid-cols-1 _grid-cols-2--m _gap-2" },
    [
      _vm.isLanguageSelectorVisible
        ? _c(
            "div",
            [
              _c(
                "language-selector",
                {
                  attrs: {
                    "display-name":
                      _vm.Resources.Layout.LanguageSelectorModalLabel,
                    "has-transparent-bg": "",
                  },
                },
                [
                  _c(
                    "label",
                    { staticClass: "gfu-field__label _tc--light _mb-1" },
                    [
                      _c("span", { attrs: { "data-qa": "field-label-text" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.Resources.Layout.LanguageSelectorModalLabel
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLanguageSelectorVisible
        ? _c(
            "div",
            { staticClass: "_flex _ai-c _order-3--m _col-span-2--m" },
            [
              _c("base-icon", {
                staticClass: "_pr-2",
                attrs: { size: "lg", name: "lightbulb" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gfu-bt--caption" },
                [
                  _c(
                    "localize",
                    {
                      attrs: {
                        resource:
                          _vm.Resources.Layout
                            .LanguageDropdownReportTranslationIssueParagraph,
                      },
                    },
                    [
                      _c(
                        "base-link",
                        {
                          attrs: {
                            "format-key": "0",
                            url: _vm.contactTranslationUrl,
                            "data-qa": "footer-translation-issue-report-link",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.Resources.Layout
                                  .LanguageDropdownReportTranslationIssueLink
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDarkModeEnabled
        ? _c(
            "div",
            { staticClass: "_order-2--l" },
            [
              _c("theme-selector", { attrs: { "has-transparent-bg": "" } }, [
                _c(
                  "div",
                  {
                    staticClass: "gfu-field__label _tc--light _mb-1",
                    attrs: { "data-qa": "field-label-text" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.Resources.Layout.ThemeSelectorLabel) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }